import FancyboxModule from './shared/utils/fancybox-module.js';

// Smooth scroll to the Full product description
class productDescriptionLink extends HTMLElement {
  constructor() {
    super();

    this.fancybox();

    this.scrollToTarget = this.scrollToTarget.bind(this);
  }

  connectedCallback() {
    this.abortController = new AbortController();
    this.scrollElement = this.querySelector('.js [data-description-link]');

    if (this.scrollElement) {
      this.scrollElement.addEventListener('click', this.scrollToTarget, { signal: this.abortController.signal });
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  /*
   * Create fancybox
   */
  fancybox() {
    FancyboxModule();
  }

  // Scroll to Element
  scrollToTarget(event) {
    event.preventDefault();
    // Get the targetElement by ID
    const targetElement = document.getElementById('description');

    // Check: if actual targetElement exists in the page
    if (targetElement !== null) {
      // Scroll to the targetElement
      window.scrollTo({
        top: targetElement.offsetTop,
        left: 0,
        behavior: 'smooth',
      });
    }
  }
}

// Load product-description-link if that exists
if (!customElements.get('product-description-link')) {
  customElements.define('product-description-link', productDescriptionLink);
}
